// import React, { useState, useEffect, useContext } from "react";
// import { EnergyHorizontalLogApi } from "../../../../../api/Api";
// import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi';
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
// import ExportPdf from "../../../../../components/exportPdf/ExportPdf";
// import logo from '../../../../../assets/img/logos/logo 2.png';

// export function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const tenDaysAgo = new Date(date);
//   tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
//   const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];
//   return {
//     Today: formattedCurrentDate,
//     LastDay: formattedTenDaysAgo,
//   };
// }

// export default function EnergyHorizontalLog() {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const [startDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//   const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10;
//   const [totalPages, setTotalPages] = useState(1);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     PASS_KEY: localStorage.getItem("KEY") || "xyz",
//     LCODE: localStorage.getItem("LCODE") || "",
//     DT1: startDate,
//     DT2: endDate,
//     WEB_KEY: "WEBXYZ321",

//   };

//   const fetchLogData = async () => {
//     setLoading(true);
//     setError(null);
//     setLogData([]);
//     try {
//       const res = await EnergyHorizontalLogApi(credentials);
//       if (res?.KWH_MIS && Array.isArray(res.KWH_MIS)) {
//         setLogData(res.KWH_MIS);
//         setTotalPages(Math.ceil(res.KWH_MIS.length / rowsPerPage));
//         setCurrentPage(1);
//       } else {
//         setLogData([]);
//         setTotalPages(1);
//       }
//     } catch (err) {
//       setError("Failed to fetch data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, [startDate, endDate]);

//   const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

//   const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//   const paginatedData = logData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   const goToPage = (page) => {
//     if (page > 0 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   const exportToExcel = async () => {
//     await ExportExcel(
//       ImageUrl,
//       logData,
//       startDate,
//       endDate,
//       "Energy Log Horizontal Report",
//       LoggedInUserInfo
//     );
//   };

//   const exportToPDF = async () => {
//     await ExportPdf(
//       ImageUrl,
//       paginatedData,
//       startDate,
//       endDate,
//       "Energy Log Horizontal Report",
//       LoggedInUserInfo,
//       logo,
//       tableHeaders
//     );
//   };

//   return (
//     <div style={{ padding: "10px", fontFamily: "Arial, sans-serif" }}>
//       <div className="row">
//         <div className="col-md-12">
//           <div style={containerStyle}>
//             <p style={responsiveHeaderStyle}>Energy Log Horizontal Report</p>
//             <div style={responsiveControlsStyle}>
//               <label>
//                 From
//                 <input
//                   type="date"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   style={inputStyle}
//                 />
//               </label>
//               <label>
//                 To
//                 <input
//                   type="date"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   style={inputStyle}
//                 />
//               </label>
//               <button onClick={fetchLogData} style={buttonStyle}>Show</button>
//               <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
//               <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="table-responsive">
//         <table id="log-table" className="table table-bordered table-striped table-hover">
//           <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//             <tr>
//               {tableHeaders.map((header, index) => (
//                 <th
//                   key={index}
//                   className="text-center align-middle"
//                   style={{
//                     color: "rgb(53, 110, 53)",
//                     padding: "12px 10px",
//                     whiteSpace: "nowrap",
//                     minWidth: "100px",
//                     fontSize: "14px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {header.replace(/_/g, " ")}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td
//                   colSpan={tableHeaders.length}
//                   className="text-center"
//                   style={{ padding: "15px", fontSize: "12px", color: "gray" }}
//                 >
//                   Loading...
//                 </td>
//               </tr>
//             ) : paginatedData.length > 0 ? (
//               paginatedData.map((item, rowIndex) => (
//                 <tr key={rowIndex} className="table-row-hover">
//                   {tableHeaders.map((key, colIndex) => (
//                     <td
//                       key={colIndex}
//                       className="text-center align-middle"
//                       style={{
//                         padding: "10px",
//                         whiteSpace: "nowrap",
//                         minWidth: "100px",
//                         verticalAlign: "middle",
//                       }}
//                     >
//                       {item[key] !== null && item[key] !== undefined ? item[key] : ""}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={tableHeaders.length}
//                   className="text-center"
//                   style={{ padding: "15px", fontSize: "16px", color: "gray" }}
//                 >
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//       <div style={{ textAlign: "right", marginTop: "20px" }}>
//         <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>Prev</button>
//         <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages}</span>
//         <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>Next</button>
//       </div>
//       {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
//     </div>
//   );
// }

// const containerStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   flexWrap: "wrap",
//   marginBottom: "7px",
//   border: "1px solid lightgray",
//   padding: "3px",
//   borderRadius: "7px"
// };

// const responsiveHeaderStyle = {
//   fontWeight: "bold",
//   margin: "0",
// };

// const responsiveControlsStyle = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "10px",
//   justifyContent: "center",
// };

// const inputStyle = {
//   padding: "3px 6px",
//   borderRadius: "14px",
//   border: "1px solid #ccc",
//   marginLeft: "5px",
//   fontSize: "10px",
// };

// const buttonStyle = {
//   backgroundColor: "#007BFF",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "2px 9px",
//   cursor: "pointer",
//   fontSize: "10px",
// };

// const exportButtonStyle = {
//   backgroundColor: "darkblue",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "3px 9px",
//   cursor: "pointer",
//   fontSize: "11px",
// };

// const exportButtonStyle2 = {
//   backgroundColor: "#f44336",
//   color: "#fff",
//   border: "none",
//   borderRadius: "14px",
//   padding: "3px 9px",
//   cursor: "pointer",
//   fontSize: "11px",
// };

// const paginationButtonStyle = {
//   backgroundColor: "white",
//   color: "#356E35",
//   border: "1px solid #ddd",
//   borderRadius: "7px",
//   padding: "6px 12px",
//   cursor: "pointer",
//   fontSize: "14px",
//   margin: "0 5px",
// };

import React, { useState, useEffect, useContext } from "react";
import { EnergyHorizontalLogApi } from "../../../../../api/Api";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi';
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../components/exportPdf/ExportPdf";
import logo from '../../../../../assets/img/logos/logo 2.png';

export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0];
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];
  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

export default function EnergyHorizontalLog() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);

  const [startDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    PASS_KEY: localStorage.getItem("KEY") || "xyz",
    LCODE: localStorage.getItem("LCODE") || "",
    DT1: startDate,
    DT2: endDate,
    WEB_KEY: "WEBXYZ321",
  };

  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    setLogData([]);
    try {
      const res = await EnergyHorizontalLogApi(credentials);
      if (res?.KWH_MIS && Array.isArray(res.KWH_MIS)) {
        setLogData(res.KWH_MIS);
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, [startDate, endDate]);

  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

  const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

  const exportToExcel = async () => {
    await ExportExcel(
      ImageUrl,
      logData,
      startDate,
      endDate,
      "Energy Log Horizontal Report",
      LoggedInUserInfo
    );
  };

  const exportToPDF = async () => {
    await ExportPdf(
      ImageUrl,
      logData, // all data on one page
      startDate,
      endDate,
      "Energy Log Horizontal Report",
      LoggedInUserInfo,
      logo,
      tableHeaders
    );
  };

  return (
    <div style={{ padding: "10px", fontFamily: "Arial, sans-serif" }}>
      <div className="row">
        <div className="col-md-12">
          <div style={containerStyle}>
            <p style={responsiveHeaderStyle}>Energy Log Horizontal Report</p>
            <div style={responsiveControlsStyle}>
              <label>
                From
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={inputStyle}
                />
              </label>
              <label>
                To
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={inputStyle}
                />
              </label>
              <button onClick={fetchLogData} style={buttonStyle}>Show</button>
              <button onClick={exportToExcel} style={exportButtonStyle}>Excel</button>
              <button onClick={exportToPDF} style={exportButtonStyle2}>PDF</button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="table-responsive">
        <table id="log-table" className="table table-bordered table-striped table-hover">
          <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
            <tr>
              {tableHeaders.map((header, index) => (
                <th
                  key={index}
                  className="text-center align-middle"
                  style={{
                    color: "rgb(53, 110, 53)",
                    padding: "12px 10px",
                    whiteSpace: "nowrap",
                    minWidth: "100px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {header.replace(/_/g, " ")}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={tableHeaders.length} className="text-center" style={{ padding: "15px", color: "gray" }}>
                  Loading...
                </td>
              </tr>
            ) : logData.length > 0 ? (
              logData.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  {tableHeaders.map((key, colIndex) => (
                    <td
                      key={colIndex}
                      className="text-center align-middle"
                      style={{
                        padding: "10px",
                        whiteSpace: "nowrap",
                        minWidth: "100px",
                      }}
                    >
                      {item[key] ?? ""}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={tableHeaders.length} className="text-center" style={{ padding: "15px", color: "gray" }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div> */}

      <div className="table-responsive">
        <table id="log-table" className="table table-bordered table-striped table-hover">
          <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
            <tr>
              {tableHeaders.map((header, index) => (
                <th
                  key={index}
                  className="text-start align-middle"
                  style={{
                    color: "rgb(53, 110, 53)",
                    padding: "12px 10px",
                    whiteSpace: "nowrap",
                    minWidth: "100px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {header.replace(/_/g, " ")}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={tableHeaders.length} className="text-start" style={{ padding: "15px", color: "gray" }}>
                  Loading...
                </td>
              </tr>
            ) : logData.length > 0 ? (
              logData.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  {tableHeaders.map((key, colIndex) => (
                    <td
                      key={colIndex}
                      className="text-start align-middle"
                      style={{
                        padding: "10px",
                        whiteSpace: "nowrap",
                        minWidth: "100px",
                      }}
                    >
                      {item[key] ?? ""}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={tableHeaders.length} className="text-start" style={{ padding: "15px", color: "gray" }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
    </div>
  );
}

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "3px",
  borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "3px 6px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  marginLeft: "5px",
  fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};

const exportButtonStyle = {
  backgroundColor: "darkblue",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const exportButtonStyle2 = {
  backgroundColor: "#f44336",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};
